/* eslint-disable */
import { staffMemberDetailsFragment } from "@saleor/fragments/staff";
import { TypedQuery } from "@saleor/queries";
import gql from "graphql-tag";
import {
  updateByMyself,
  updateByMyselfVariables
} from "@saleor/staffmyself/types/updateByMyself";

// const staffList = gql`
//   ${staffMemberFragment}
//   query StaffList(
//     $first: Int
//     $after: String
//     $last: Int
//     $before: String
//     $filter: StaffUserInput
//     $sort: UserSortingInput
//   ) {
//     staffUsers(
//       before: $before
//       after: $after
//       first: $first
//       last: $last
//       filter: $filter
//       sortBy: $sort
//     ) {
//       edges {
//         cursor
//         node {
//           ...StaffMemberFragment
//           avatar(size: 48) {
//             url
//           }
//         }
//       }
//       pageInfo {
//         hasPreviousPage
//         hasNextPage
//         startCursor
//         endCursor
//       }
//     }
//   }
// `;
// export const useStaffListQuery = makeQuery<StaffList, StaffListVariables>(
//   staffList
// );

// export const staffMemberDetails = gql`
//   ${staffMemberDetailsFragment}
//   query StaffMemberDetails($id: ID!) {
//     user(id: $id) {
//       ...StaffMemberDetailsFragment
//     }
//   }
// `;
// export const TypedStaffMemberDetailsQuery = TypedQuery<
//   StaffMemberDetails,
//   StaffMemberDetailsVariables
// >(staffMemberDetails);

// 用新的详情接口
export const updateByMyselfDetails = gql`
  ${staffMemberDetailsFragment}
  query updateByMyself($id: ID!) {
    user(id: $id) {
      ...StaffMemberDetailsFragment
    }
  }
`;
export const TypedStaffMemberDetailsQuery = TypedQuery<
  updateByMyself,
  updateByMyselfVariables
>(updateByMyselfDetails);
